import { AdminLayout } from "@/components/layout/AdminLayout";
import { Button } from "@/components/ui/button";

const GlobalSearch = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="mb-4 text-3xl font-bold text-foreground">
              Global search
            </h2>
            <div className="flex gap-8 text-sm">
              <div>
                <div className="text-muted-foreground">
                  Total number of Records
                </div>
                <div className="text-lg font-semibold">692</div>
              </div>
              <div>
                <div className="text-muted-foreground">Total Pages</div>
                <div className="text-lg font-semibold">07</div>
              </div>
            </div>
          </div>
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
            Export Data
          </Button>
        </div>

        <div className="overflow-hidden rounded-lg border border-border bg-card">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Search Result
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold uppercase">
                  Count
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {[
                { term: "Pratikraman", count: 11 },
                { term: "Pooja", count: 11 },
                { term: "Mantra", count: 11 },
                { term: "Osho", count: 9 },
                { term: "Jyotish", count: 7 },
                { term: "Devendramuni", count: 5 },
                { term: "Tatwarth sutra", count: 5 },
                { term: "Acharam", count: 5 },
                { term: "Shant. sudharas", count: 4 },
                { term: "Shalaka", count: 4 },
              ].map(item => (
                <tr key={item.term} className="hover:bg-muted/30">
                  <td className="px-6 py-3 text-sm">{item.term}</td>
                  <td className="px-6 py-3 text-sm">{item.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-between">
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
            Export Data
          </Button>
          <div className="flex gap-2">
            <Button variant="outline" size="sm">
              « First
            </Button>
            <Button variant="outline" size="sm">
              ‹ Back
            </Button>
            <Button size="sm" className="bg-primary text-primary-foreground">
              1
            </Button>
            <Button variant="outline" size="sm">
              Next ›
            </Button>
            <Button variant="outline" size="sm">
              Last »
            </Button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default GlobalSearch;
